(function () {
  var PREFERRED = ['ae', 'sa', 'qa', 'kw', 'bh', 'om'];

  // [iso2, name, dial code]
  var COUNTRIES = [
    ['ad', 'Andorra', '+376'],
    ['ae', 'United Arab Emirates', '+971'],
    ['af', 'Afghanistan', '+93'],
    ['ag', 'Antigua and Barbuda', '+1268'],
    ['ai', 'Anguilla', '+1264'],
    ['al', 'Albania', '+355'],
    ['am', 'Armenia', '+374'],
    ['ao', 'Angola', '+244'],
    ['ar', 'Argentina', '+54'],
    ['as', 'American Samoa', '+1684'],
    ['at', 'Austria', '+43'],
    ['au', 'Australia', '+61'],
    ['aw', 'Aruba', '+297'],
    ['ax', 'Åland Islands', '+358'],
    ['az', 'Azerbaijan', '+994'],
    ['ba', 'Bosnia and Herzegovina', '+387'],
    ['bb', 'Barbados', '+1246'],
    ['bd', 'Bangladesh', '+880'],
    ['be', 'Belgium', '+32'],
    ['bf', 'Burkina Faso', '+226'],
    ['bg', 'Bulgaria', '+359'],
    ['bh', 'Bahrain', '+973'],
    ['bi', 'Burundi', '+257'],
    ['bj', 'Benin', '+229'],
    ['bl', 'Saint Barthélemy', '+590'],
    ['bm', 'Bermuda', '+1441'],
    ['bn', 'Brunei', '+673'],
    ['bo', 'Bolivia', '+591'],
    ['bq', 'Caribbean Netherlands', '+599'],
    ['br', 'Brazil', '+55'],
    ['bs', 'Bahamas', '+1242'],
    ['bt', 'Bhutan', '+975'],
    ['bw', 'Botswana', '+267'],
    ['by', 'Belarus', '+375'],
    ['bz', 'Belize', '+501'],
    ['ca', 'Canada', '+1'],
    ['cc', 'Cocos (Keeling) Islands', '+61'],
    ['cd', 'Congo - Kinshasa', '+243'],
    ['cf', 'Central African Republic', '+236'],
    ['cg', 'Congo - Brazzaville', '+242'],
    ['ch', 'Switzerland', '+41'],
    ['ci', "Côte d'Ivoire", '+225'],
    ['ck', 'Cook Islands', '+682'],
    ['cl', 'Chile', '+56'],
    ['cm', 'Cameroon', '+237'],
    ['cn', 'China', '+86'],
    ['co', 'Colombia', '+57'],
    ['cr', 'Costa Rica', '+506'],
    ['cu', 'Cuba', '+53'],
    ['cv', 'Cape Verde', '+238'],
    ['cw', 'Curaçao', '+599'],
    ['cx', 'Christmas Island', '+61'],
    ['cy', 'Cyprus', '+357'],
    ['cz', 'Czechia', '+420'],
    ['de', 'Germany', '+49'],
    ['dj', 'Djibouti', '+253'],
    ['dk', 'Denmark', '+45'],
    ['dm', 'Dominica', '+1767'],
    ['do', 'Dominican Republic', '+1809'],
    ['dz', 'Algeria', '+213'],
    ['ec', 'Ecuador', '+593'],
    ['ee', 'Estonia', '+372'],
    ['eg', 'Egypt', '+20'],
    ['eh', 'Western Sahara', '+212'],
    ['er', 'Eritrea', '+291'],
    ['es', 'Spain', '+34'],
    ['et', 'Ethiopia', '+251'],
    ['fi', 'Finland', '+358'],
    ['fj', 'Fiji', '+679'],
    ['fk', 'Falkland Islands', '+500'],
    ['fm', 'Micronesia', '+691'],
    ['fo', 'Faroe Islands', '+298'],
    ['fr', 'France', '+33'],
    ['ga', 'Gabon', '+241'],
    ['gb', 'United Kingdom', '+44'],
    ['gd', 'Grenada', '+1473'],
    ['ge', 'Georgia', '+995'],
    ['gf', 'French Guiana', '+594'],
    ['gg', 'Guernsey', '+44'],
    ['gh', 'Ghana', '+233'],
    ['gi', 'Gibraltar', '+350'],
    ['gl', 'Greenland', '+299'],
    ['gm', 'Gambia', '+220'],
    ['gn', 'Guinea', '+224'],
    ['gp', 'Guadeloupe', '+590'],
    ['gq', 'Equatorial Guinea', '+240'],
    ['gr', 'Greece', '+30'],
    ['gt', 'Guatemala', '+502'],
    ['gu', 'Guam', '+1671'],
    ['gw', 'Guinea-Bissau', '+245'],
    ['gy', 'Guyana', '+592'],
    ['hk', 'Hong Kong', '+852'],
    ['hn', 'Honduras', '+504'],
    ['hr', 'Croatia', '+385'],
    ['ht', 'Haiti', '+509'],
    ['hu', 'Hungary', '+36'],
    ['id', 'Indonesia', '+62'],
    ['ie', 'Ireland', '+353'],
    ['il', 'Israel', '+972'],
    ['im', 'Isle of Man', '+44'],
    ['in', 'India', '+91'],
    ['io', 'British Indian Ocean Territory', '+246'],
    ['iq', 'Iraq', '+964'],
    ['ir', 'Iran', '+98'],
    ['is', 'Iceland', '+354'],
    ['it', 'Italy', '+39'],
    ['je', 'Jersey', '+44'],
    ['jm', 'Jamaica', '+1876'],
    ['jo', 'Jordan', '+962'],
    ['jp', 'Japan', '+81'],
    ['ke', 'Kenya', '+254'],
    ['kg', 'Kyrgyzstan', '+996'],
    ['kh', 'Cambodia', '+855'],
    ['ki', 'Kiribati', '+686'],
    ['km', 'Comoros', '+269'],
    ['kn', 'Saint Kitts and Nevis', '+1869'],
    ['kp', 'North Korea', '+850'],
    ['kr', 'South Korea', '+82'],
    ['kw', 'Kuwait', '+965'],
    ['ky', 'Cayman Islands', '+1345'],
    ['kz', 'Kazakhstan', '+7'],
    ['la', 'Laos', '+856'],
    ['lb', 'Lebanon', '+961'],
    ['lc', 'Saint Lucia', '+1758'],
    ['li', 'Liechtenstein', '+423'],
    ['lk', 'Sri Lanka', '+94'],
    ['lr', 'Liberia', '+231'],
    ['ls', 'Lesotho', '+266'],
    ['lt', 'Lithuania', '+370'],
    ['lu', 'Luxembourg', '+352'],
    ['lv', 'Latvia', '+371'],
    ['ly', 'Libya', '+218'],
    ['ma', 'Morocco', '+212'],
    ['mc', 'Monaco', '+377'],
    ['md', 'Moldova', '+373'],
    ['me', 'Montenegro', '+382'],
    ['mf', 'Saint Martin', '+590'],
    ['mg', 'Madagascar', '+261'],
    ['mh', 'Marshall Islands', '+692'],
    ['mk', 'North Macedonia', '+389'],
    ['ml', 'Mali', '+223'],
    ['mm', 'Myanmar', '+95'],
    ['mn', 'Mongolia', '+976'],
    ['mo', 'Macao', '+853'],
    ['mp', 'Northern Mariana Islands', '+1670'],
    ['mq', 'Martinique', '+596'],
    ['mr', 'Mauritania', '+222'],
    ['ms', 'Montserrat', '+1664'],
    ['mt', 'Malta', '+356'],
    ['mu', 'Mauritius', '+230'],
    ['mv', 'Maldives', '+960'],
    ['mw', 'Malawi', '+265'],
    ['mx', 'Mexico', '+52'],
    ['my', 'Malaysia', '+60'],
    ['mz', 'Mozambique', '+258'],
    ['na', 'Namibia', '+264'],
    ['nc', 'New Caledonia', '+687'],
    ['ne', 'Niger', '+227'],
    ['nf', 'Norfolk Island', '+672'],
    ['ng', 'Nigeria', '+234'],
    ['ni', 'Nicaragua', '+505'],
    ['nl', 'Netherlands', '+31'],
    ['no', 'Norway', '+47'],
    ['np', 'Nepal', '+977'],
    ['nr', 'Nauru', '+674'],
    ['nu', 'Niue', '+683'],
    ['nz', 'New Zealand', '+64'],
    ['om', 'Oman', '+968'],
    ['pa', 'Panama', '+507'],
    ['pe', 'Peru', '+51'],
    ['pf', 'French Polynesia', '+689'],
    ['pg', 'Papua New Guinea', '+675'],
    ['ph', 'Philippines', '+63'],
    ['pk', 'Pakistan', '+92'],
    ['pl', 'Poland', '+48'],
    ['pm', 'Saint Pierre and Miquelon', '+508'],
    ['pr', 'Puerto Rico', '+1787'],
    ['ps', 'Palestine', '+970'],
    ['pt', 'Portugal', '+351'],
    ['pw', 'Palau', '+680'],
    ['py', 'Paraguay', '+595'],
    ['qa', 'Qatar', '+974'],
    ['re', 'Réunion', '+262'],
    ['ro', 'Romania', '+40'],
    ['rs', 'Serbia', '+381'],
    ['ru', 'Russia', '+7'],
    ['rw', 'Rwanda', '+250'],
    ['sa', 'Saudi Arabia', '+966'],
    ['sb', 'Solomon Islands', '+677'],
    ['sc', 'Seychelles', '+248'],
    ['sd', 'Sudan', '+249'],
    ['se', 'Sweden', '+46'],
    ['sg', 'Singapore', '+65'],
    ['sh', 'Saint Helena', '+290'],
    ['si', 'Slovenia', '+386'],
    ['sj', 'Svalbard and Jan Mayen', '+47'],
    ['sk', 'Slovakia', '+421'],
    ['sl', 'Sierra Leone', '+232'],
    ['sm', 'San Marino', '+378'],
    ['sn', 'Senegal', '+221'],
    ['so', 'Somalia', '+252'],
    ['sr', 'Suriname', '+597'],
    ['ss', 'South Sudan', '+211'],
    ['st', 'São Tomé and Príncipe', '+239'],
    ['sv', 'El Salvador', '+503'],
    ['sx', 'Sint Maarten', '+1721'],
    ['sy', 'Syria', '+963'],
    ['sz', 'Eswatini', '+268'],
    ['tc', 'Turks and Caicos Islands', '+1649'],
    ['td', 'Chad', '+235'],
    ['tg', 'Togo', '+228'],
    ['th', 'Thailand', '+66'],
    ['tj', 'Tajikistan', '+992'],
    ['tk', 'Tokelau', '+690'],
    ['tl', 'Timor-Leste', '+670'],
    ['tm', 'Turkmenistan', '+993'],
    ['tn', 'Tunisia', '+216'],
    ['to', 'Tonga', '+676'],
    ['tr', 'Turkey', '+90'],
    ['tt', 'Trinidad and Tobago', '+1868'],
    ['tv', 'Tuvalu', '+688'],
    ['tw', 'Taiwan', '+886'],
    ['tz', 'Tanzania', '+255'],
    ['ua', 'Ukraine', '+380'],
    ['ug', 'Uganda', '+256'],
    ['us', 'United States', '+1'],
    ['uy', 'Uruguay', '+598'],
    ['uz', 'Uzbekistan', '+998'],
    ['va', 'Vatican City', '+379'],
    ['vc', 'Saint Vincent and the Grenadines', '+1784'],
    ['ve', 'Venezuela', '+58'],
    ['vg', 'British Virgin Islands', '+1284'],
    ['vi', 'U.S. Virgin Islands', '+1340'],
    ['vn', 'Vietnam', '+84'],
    ['vu', 'Vanuatu', '+678'],
    ['wf', 'Wallis and Futuna', '+681'],
    ['ws', 'Samoa', '+685'],
    ['xk', 'Kosovo', '+383'],
    ['ye', 'Yemen', '+967'],
    ['yt', 'Mayotte', '+262'],
    ['za', 'South Africa', '+27'],
    ['zm', 'Zambia', '+260'],
    ['zw', 'Zimbabwe', '+263']
  ];

  function flagUrl(sampleSrc, iso) {
    return sampleSrc.replace(/flag-[a-z]{2}\.svg(\?.*)?$/i, 'flag-' + iso + '.svg');
  }

  function initPhoneField(root) {
    var trigger = root.querySelector('[data-gp-phone-trigger]');
    var panel = root.querySelector('[data-gp-phone-panel]');
    var flagImg = root.querySelector('[data-gp-phone-flag]');
    var dialEl = root.querySelector('[data-gp-phone-dial]');
    var countryInput = root.querySelector('[data-gp-phone-country]');
    var searchInput = root.querySelector('[data-gp-phone-search]');
    var listEl = root.querySelector('[data-gp-phone-list]');
    var numberInput = root.querySelector('[data-gp-phone-number]');

    if (!trigger || !panel || !listEl || !flagImg) return;

    var sampleFlagSrc = flagImg.getAttribute('src');

    function buildOption(country) {
      var li = document.createElement('li');
      li.className = 'gp-phone__option';
      li.setAttribute('role', 'option');
      li.dataset.iso = country[0];
      li.dataset.name = country[1].toLowerCase();
      li.dataset.dial = country[2];
      li.innerHTML =
        '<img src="' + flagUrl(sampleFlagSrc, country[0]) + '" alt="" width="22" height="16" loading="lazy">' +
        '<span class="gp-phone__option-name">' + country[1] + '</span>' +
        '<span class="gp-phone__option-dial">' + country[2] + '</span>';
      return li;
    }

    var preferredCountries = PREFERRED.map(function (iso) {
      for (var i = 0; i < COUNTRIES.length; i++) {
        if (COUNTRIES[i][0] === iso) return COUNTRIES[i];
      }
      return null;
    }).filter(Boolean);

    var restCountries = COUNTRIES.filter(function (c) {
      return PREFERRED.indexOf(c[0]) === -1;
    }).sort(function (a, b) {
      return a[1].localeCompare(b[1]);
    });

    var listFragment = document.createDocumentFragment();
    preferredCountries.forEach(function (c) {
      listFragment.appendChild(buildOption(c));
    });

    var divider = document.createElement('li');
    divider.className = 'gp-phone__divider';
    divider.setAttribute('role', 'presentation');
    listFragment.appendChild(divider);

    restCountries.forEach(function (c) {
      listFragment.appendChild(buildOption(c));
    });

    var empty = document.createElement('li');
    empty.className = 'gp-phone__empty';
    empty.setAttribute('role', 'presentation');
    empty.hidden = true;
    empty.textContent = 'No countries found';
    listFragment.appendChild(empty);

    listEl.appendChild(listFragment);

    var options = Array.prototype.slice.call(listEl.querySelectorAll('.gp-phone__option'));

    function openPanel() {
      panel.hidden = false;
      root.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
      if (searchInput) {
        searchInput.value = '';
        filterOptions('');
        searchInput.focus();
      }
    }

    function closePanel() {
      panel.hidden = true;
      root.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function filterOptions(query) {
      var q = query.trim().toLowerCase();
      var anyVisible = false;
      options.forEach(function (option) {
        var matches =
          !q ||
          option.dataset.name.indexOf(q) !== -1 ||
          option.dataset.dial.indexOf(q) !== -1 ||
          option.dataset.iso.indexOf(q) !== -1;
        option.hidden = !matches;
        if (matches) anyVisible = true;
      });
      divider.hidden = !!q;
      empty.hidden = anyVisible;
    }

    function selectCountry(li) {
      var img = li.querySelector('img');
      flagImg.setAttribute('src', img.getAttribute('src'));
      dialEl.textContent = li.dataset.dial;
      if (countryInput) countryInput.value = li.dataset.iso.toUpperCase();
      closePanel();
      if (numberInput) numberInput.focus();
    }

    trigger.addEventListener('click', function () {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterOptions(searchInput.value);
      });
    }

    listEl.addEventListener('click', function (event) {
      var li = event.target.closest('.gp-phone__option');
      if (li) selectCountry(li);
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closePanel();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePanel();
        trigger.focus();
      }
    });
  }

  document.querySelectorAll('[data-gp-phone]').forEach(initPhoneField);
})();
